import { render, staticRenderFns } from "./PayMusic.vue?vue&type=template&id=0af31d73&scoped=true&"
import script from "./PayMusic.vue?vue&type=script&lang=js&"
export * from "./PayMusic.vue?vue&type=script&lang=js&"
import style0 from "./PayMusic.vue?vue&type=style&index=0&id=0af31d73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af31d73",
  null
  
)

export default component.exports